interface VehicleDetailHeaderProps {
  vehicle: any;
  titleColor: string;
  textColor: string;
  formatPrice: (price: number) => string;
}

export function VehicleDetailHeader({
  vehicle,
  titleColor,
  textColor,
  formatPrice,
}: VehicleDetailHeaderProps) {
  const tags: { label: string; accent?: boolean }[] = [];

  if (vehicle.isZeroKm) {
    tags.push({ label: 'Zero KM', accent: true });
  } else if (vehicle.mileage > 0) {
    tags.push({ label: 'Seminovo' });
  }

  const ficha = [
    { label: 'Marca', value: vehicle.brand },
    { label: 'Modelo', value: vehicle.model },
    { label: 'Ano', value: `${vehicle.manufactureYear || '—'} / ${vehicle.modelYear || '—'}` },
    { label: 'Km', value: vehicle.mileage != null ? `${vehicle.mileage.toLocaleString('pt-BR')} km` : '—' },
    { label: 'Câmbio', value: vehicle.transmission || '—' },
    { label: 'Combustível', value: vehicle.fuel || '—' },
  ];

  return (
    <header className="wl7-vd-header wl7-vd-header--band">
      <div className="wl7-vd-header__row">
        <div>
          {tags.length > 0 && (
            <div className="wl7-vd-tags">
              {tags.map((tag) => (
                <span
                  key={tag.label}
                  className={`wl7-vd-tag${tag.accent ? ' wl7-vd-tag--accent' : ''}`}
                >
                  {tag.label}
                </span>
              ))}
            </div>
          )}
          <h1 className="wl7-vd-header__title" style={{ color: titleColor }}>
            {vehicle.brand} {vehicle.model}
          </h1>
          {vehicle.version && (
            <p className="wl7-vd-header__version" style={{ color: textColor }}>
              {vehicle.version}
            </p>
          )}
        </div>
        <div className="wl7-vd-header__price-block">
          <span className="wl7-vd-header__price-label">Preço</span>
          <div className="wl7-vd-header__price">{formatPrice(vehicle.price)}</div>
        </div>
      </div>

      <dl className="wl7-vd-ficha">
        {ficha.map((item) => (
          <div key={item.label} className="wl7-vd-ficha-item">
            <dt>{item.label}</dt>
            <dd>{item.value}</dd>
          </div>
        ))}
      </dl>
    </header>
  );
}
